import { Provider } from 'react-redux';
import { persistor, store } from '../redux/store.jsx';
import { PersistGate } from 'redux-persist/integration/react';
import { ConfigProvider } from 'antd';
import skSK from 'antd/lib/locale/sk_SK';
import AppRoutes from './routes/AppRoutes.jsx';

const AppProvider = () => {
  return (
    <ConfigProvider
      locale={skSK}
      theme={{
        components: {
          Table: {
            cellPaddingBlock: 5,
            cellPaddingBlockMD: 3,
            cellPaddingBlockSM: 2,
          },
        },
      }}
    >
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <AppRoutes />
        </PersistGate>
      </Provider>
    </ConfigProvider>
  );
};

export default AppProvider;
